// @ts-nocheck
import React from 'react';

import {
  CLEAR_PLUS_TABS,
  useClearPlusByOnDemand,
} from '../../Contexts/ClearPlusByOnDemandProvider';
import ClearButtonView from '../../Components/ClearButton';

function ClearFAQButton() {
  const { onOpenDrawer, isClearByOnDemand, setActiveTab } = useClearPlusByOnDemand();

  const handleOpenDrawer = () => {
    onOpenDrawer();
    setActiveTab(CLEAR_PLUS_TABS.FAQ);
  };

  if (!isClearByOnDemand) return null;

  return <ClearButtonView onClick={handleOpenDrawer} />;
}

export default ClearFAQButton;
